import React from "react"
import {
	Box,
	Grid,
	Dialog,
	Button,
	IconButton,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	useTheme,
} from "@mui/material"

import Icon from "@mdi/react"
import { mdiHelpCircle, mdiClose } from "@mdi/js"

const MeasureCylinderDialog = () => {
	const [open, setOpen] = React.useState(false)
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down("lg"))

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}
	return (
		<>
			<Box mb={-1}>
				<div style={{ display: "flex", alignItems: "center" }}>
					<Box mr={-1}>
						<strong>Zylinderlänge wählen</strong>
					</Box>
					<IconButton onClick={handleClickOpen} size="large">
						<Icon path={mdiHelpCircle} size={0.8} color="#4691CE" />
					</IconButton>
				</div>
				<Dialog
					fullScreen={fullScreen}
					open={open}
					onClose={handleClose}
					maxWidth={"md"}
					aria-labelledby="zylinder-messen"
				>
					<DialogTitle
						id="zylinder-messen-dialog"
						style={{
							borderBottom: "1px solid #B8BCBF",
						}}
					>
						<div>
							<strong>Wie messe ich einen Zylinder</strong>
						</div>
						<Button
							onClick={handleClose}
							color="primary"
							style={{ position: "absolute", top: 13, right: 10 }}
						>
							<Icon path={mdiClose} size={1} />
						</Button>
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<Box mt={3}>
									<img
										alt="eingebauter-zustand"
										src="https://res.cloudinary.com/safehero/image/upload/v1573210742/ProductDetailPage/eingebauter-zustand.svg"
										style={{ width: "100%", maxHeight: "200px" }}
									/>
								</Box>
							</Grid>
							<Grid item xs={12} md={8}>
								<div>
									<strong>Im eingebauten Zustand:</strong>
								</div>
								<p>
									Für den perfekten Sitz: Messen Sie vor dem Kauf die Abstände vom
									Mittelpunkt der Schraube, die Ihren Zylinder fixiert, bis zur
									äußeren <strong>(A)</strong> und inneren Seite{" "}
									<strong>(B)</strong> der Tür.
								</p>
								<p>
									Beim eingebauten Zylinder misst man ausgehend von der Mitte des
									in der Tür eingebauten Schlosses. Dazu orientiert man sich am
									Besten an der Zylinderbefestigungsschraube und misst bis an die
									Enden des Zylinders auf der Innen- und Außenseite. So ergeben
									sich zwei Maße, einmal Innen bis zur Mitte des Schlosses und
									einmal von Außen bis zur Mitte des Schlosses. Die Zylinderlängen
									beginnen auf jeder Seite bei 30 bzw. 31 mm und sind in 5 mm
									Schritten bis maximal 85 bzw 86 mm erhältlich.
								</p>
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={12} md={8}>
								<div>
									<strong>Im ausgebauten Zustand:</strong>
								</div>
								<p>
									Für eine exakte Messung empfehlen wir, den bestehenden Zylinder
									auszubauen und abzumessen. Dazu stecken Sie einen Schlüssel an
									und drehen die Zylinderbefestigungsschraube heraus. Jetzt kann
									der Zylinder herausgezogen werden. Sollte sich die Schließnase
									verhaken, drehen Sie bitte den Schlüssel, bis sich der Zylinder
									sanft entfernen lässt.{" "}
								</p>
								<p>
									Nun können Sie den Zylinder, ausgehend vom Befestigungsloch in
									der Mitte, auf beiden Seiten abmessen. Wenn beide Längen
									feststehen, können Sie Ihren neuen Zylinder bestellen.
								</p>
							</Grid>
							<Grid item xs={12} md={4}>
								<Box my={3}>
									<img
										alt="ausgebauter-zustand"
										src="https://res.cloudinary.com/safehero/image/upload/v1573210561/ProductDetailPage/ausgebauter-zustand.svg"
										style={{ width: "100%" }}
									/>
								</Box>
							</Grid>
						</Grid>
					</DialogContent>
				</Dialog>
			</Box>
		</>
	)
}

export default MeasureCylinderDialog
